import React from 'react';

export default function EmailNotificationComponent() {
  return (
    <div>
      <h1>Hello im email notification</h1>
    </div>
  );
}
